import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const Quantity = ({ value, onChange, label = 'Quantity:', disabled  = false}) => {
    const [selectedQuantity, setSelectedQuantity] = useState(value || "1");

    // Sync state with value prop if it changes
    useEffect(() => {
        setSelectedQuantity(value || "1");
    }, [value]);

    const handleQuantityChange = (e) => {
        setSelectedQuantity(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="Quantity" disabled={disabled} >{label}</label>
            <input
                disabled={disabled}
                type="number"
                id="Quantity"
                value={selectedQuantity}
                onChange={handleQuantityChange}
                min="1"
            />
        </div>
    );
};

export default Quantity;
